__webpack_require__.p = "/Shogi/";